import { render, staticRenderFns } from "./UtilTag.vue?vue&type=template&id=2a608804&scoped=true&"
import script from "./UtilTag.vue?vue&type=script&lang=js&"
export * from "./UtilTag.vue?vue&type=script&lang=js&"
import style0 from "./UtilTag.vue?vue&type=style&index=0&id=2a608804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a608804",
  null
  
)

export default component.exports